import Notifications from '@/components/community_settings/notifications/Notifications';
import { hasPpmAccess } from '@/utils/ppm/permissions';

export default {
    key: 'notifications',
    title: 'notification',
    component: Notifications,
    permissionChecker: hasPpmAccess,
};
